import { combineReducers } from "redux";

import cohort from "./cohort";
import dashboard from "./dashboard";
import metric from "./metric";

export default combineReducers({
  cohort,
  dashboard,
  metric,
});
